declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GOOGLE_ADS_ID = 'AW-17976457837';

const ACCOUNT_CREATED_UNVERIFIED_CONVERSION_LABEL = '3sP1CP34k5AcEO306_tC';

const ACCOUNT_CREATED_VERIFIED_CONVERSION_LABEL = '_a6ACLSz8YMcEO306_tC';

let gtagLoaded = false;

function ensureGtag() {
  if (typeof window === 'undefined') {
    return;
  }

  if (gtagLoaded || window.gtag) {
    gtagLoaded = true;

    return;
  }

  gtagLoaded = true;

  window.dataLayer = window.dataLayer || [];

  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };

  window.gtag('js', new Date());

  window.gtag('config', GOOGLE_ADS_ID);

  const script = document.createElement('script');

  script.async = true;

  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`;

  document.head.appendChild(script);
}

function trackConversion(label: string) {
  if (typeof window === 'undefined') {
    return;
  }

  ensureGtag();

  window.gtag?.('event', 'conversion', {
    send_to: `${GOOGLE_ADS_ID}/${label}`,
    value: 1.0,
    currency: 'USD',
  });
}

export function trackGoogleAdsAccountCreatedUnverifiedConversion() {
  trackConversion(ACCOUNT_CREATED_UNVERIFIED_CONVERSION_LABEL);
}

export function trackGoogleAdsAccountCreatedVerifiedConversion() {
  trackConversion(ACCOUNT_CREATED_VERIFIED_CONVERSION_LABEL);
}
